"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const client_1 = __importDefault(require("react-dom/client"));
const react_router_dom_1 = require("react-router-dom");
const react_components_1 = require("@fluentui/react-components");
const font_icons_mdl2_1 = require("@fluentui/font-icons-mdl2");
const App_1 = __importDefault(require("./App"));
(0, font_icons_mdl2_1.initializeIcons)();
const root = client_1.default.createRoot(document.getElementById('root'));
root.render(react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
    react_1.default.createElement(react_components_1.FluentProvider, { theme: react_components_1.webLightTheme },
        react_1.default.createElement(App_1.default, null))));
